import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FetchCurrentUserGQL, User } from 'src/graphql/generated';
import { SnackBarService } from './snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  currentUser$: Subject<User> = new Subject();
  currentUser: User;
  constructor(
    private http: HttpClient,
    private snackbarService: SnackBarService,
    private fetchCurrentUserGQL: FetchCurrentUserGQL
  ) { }

  updateAvatar(file: File) {
    const formData = new FormData();
    formData.append("avatar", file);
    this.http.post(`${environment.API_URI}/users/avatar`, formData).subscribe(
      result => {
        this.snackbarService.showSuccessSnackBar("Avatar modifié");
        this.fetchCurrentUser();
      },
      error => {
        this.snackbarService.showErrorSnackBar(4000, "Une erreur est survenue");

      }
    )
  }

  fetchCurrentUser(init: boolean = true) {
    return new Promise((resolve, reject) => {
      this.fetchCurrentUserGQL.fetch().subscribe(
        (result) => {

          if(result.errors) {
            this.snackbarService.showErrorSnackBar();
            reject(result.errors);
          } else {
            this.currentUser = result.data.fetchCurrentUser as User;
            this.currentUser$.next(this.currentUser);
            resolve(this.currentUser);
          }
        },
      )
    })
  }
}
